import { useState } from 'react';
import { C, DEGRADE_ACTION } from '../../theme';
import { api } from '../../api/routes';
import { messageDErreur } from '../../api/useDonnees';

/**
 * « Ajouter des choses dans la checklist sans passer par l'IA » (retour du porteur du
 * 2026-08-27). Un bouton discret sous la liste ; le formulaire valide au Entree —
 * meme patron que la case repas.
 */
export function AjouterElement({
  checklistId,
  titreListe,
  signaler,
  rafraichir,
}: {
  checklistId: string;
  titreListe: string;
  signaler: (message: string) => void;
  rafraichir: () => void;
}) {
  const [edition, setEdition] = useState(false);
  const [saisie, setSaisie] = useState('');
  const [envoi, setEnvoi] = useState(false);

  const ajouter = async () => {
    const label = saisie.trim();
    if (label === '' || envoi) return;
    setEnvoi(true);
    try {
      await api.ajouterElement(checklistId, label);
      setSaisie('');
      setEdition(false);
      rafraichir();
    } catch (cause) {
      signaler(messageDErreur(cause));
    } finally {
      setEnvoi(false);
    }
  };

  if (!edition) {
    return (
      <button
        type="button"
        aria-label={`Ajouter un élément à : ${titreListe}`}
        onClick={() => setEdition(true)}
        style={{
          alignSelf: 'flex-start',
          background: 'none',
          border: 'none',
          padding: 0,
          fontSize: 13,
          fontWeight: 800,
          fontFamily: 'inherit',
          color: C.violetTexte,
          cursor: 'pointer',
        }}
      >
        + Ajouter
      </button>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        void ajouter();
      }}
      style={{ display: 'flex', gap: 6 }}
    >
      <input
        value={saisie}
        onChange={(e) => setSaisie(e.target.value)}
        placeholder="Quoi d’autre ?"
        aria-label={`Nouvel élément pour : ${titreListe}`}
        maxLength={120}
        autoFocus
        style={{
          flex: 1,
          minWidth: 0,
          height: 36,
          border: `1px solid ${C.violetBordure}`,
          borderRadius: 10,
          padding: '0 10px',
          fontSize: 16,
          fontFamily: 'inherit',
          color: C.encre,
          // Sans fond declare, un input prend le BLANC du navigateur — et l'encre de
          // Colette etant claire, on n'y voit plus ce qu'on tape.
          background: C.carte,
          outline: 'none',
        }}
      />
      <button
        type="submit"
        disabled={envoi || saisie.trim() === ''}
        style={{
          height: 36,
          padding: '0 12px',
          border: 'none',
          borderRadius: 10,
          background: envoi || saisie.trim() === '' ? C.inactif : DEGRADE_ACTION,
          color: '#FFFFFF',
          fontSize: 13,
          fontWeight: 800,
          fontFamily: 'inherit',
          cursor: envoi || saisie.trim() === '' ? 'default' : 'pointer',
        }}
      >
        OK
      </button>
      <button
        type="button"
        onClick={() => {
          setEdition(false);
          setSaisie('');
        }}
        style={{
          height: 36,
          padding: '0 10px',
          border: `1px solid ${C.bordure}`,
          borderRadius: 10,
          background: C.carte,
          color: C.secondaire,
          fontSize: 13,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        Annuler
      </button>
    </form>
  );
}
